import React, { useEffect, useState } from 'react';
import { Horse, useHorse } from '../../contexts/HorseContext';
interface MasterDataFormProps {
  horse: Horse | null;
  onComplete: () => void;
}
export const MasterDataForm: React.FC<MasterDataFormProps> = ({
  horse,
  onComplete
}) => {
  const {
    addHorse,
    updateHorse
  } = useHorse();
  const [formData, setFormData] = useState({
    name: '',
    lineage: '',
    birthYear: '',
    breed: ''
  });
  useEffect(() => {
    if (horse) {
      setFormData({
        name: horse.name,
        lineage: horse.lineage,
        birthYear: horse.birthYear,
        breed: horse.breed
      });
    } else {
      setFormData({
        name: '',
        lineage: '',
        birthYear: '',
        breed: ''
      });
    }
  }, [horse]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Basic validation
    if (!formData.name || !formData.birthYear) {
      alert('Bitte Name und Geburtsjahr ausfüllen');
      return;
    }
    if (horse) {
      updateHorse(horse.id, formData);
    } else {
      addHorse(formData);
    }
    // Reset form
    setFormData({
      name: '',
      lineage: '',
      birthYear: '',
      breed: ''
    });
    onComplete();
  };
  const currentYear = new Date().getFullYear();
  const years = Array.from({
    length: 30
  }, (_, i) => currentYear - i);
  return <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6" data-id="element-79">
      <div data-id="element-80">
        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-81">
          Pferdename *
        </label>
        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#96c11f] focus:border-[#96c11f] focus:bg-[#96c11f]/5" required data-id="element-82" />
      </div>
      <div data-id="element-83">
        <label htmlFor="lineage" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-84">
          Abstammung
        </label>
        <input type="text" id="lineage" name="lineage" value={formData.lineage} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#96c11f] focus:border-[#96c11f] focus:bg-[#96c11f]/5" data-id="element-85" />
      </div>
      <div data-id="element-86">
        <label htmlFor="birthYear" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-87">
          Geburtsjahr *
        </label>
        <select id="birthYear" name="birthYear" value={formData.birthYear} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#96c11f] focus:border-[#96c11f] focus:bg-[#96c11f]/5" required data-id="element-88">
          <option value="" data-id="element-89">Bitte wählen</option>
          {years.map(year => <option key={year} value={year} data-id="element-90">
              {year}
            </option>)}
        </select>
      </div>
      <div data-id="element-91">
        <label htmlFor="breed" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-92">
          Rasse
        </label>
        <input type="text" id="breed" name="breed" value={formData.breed} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#96c11f] focus:border-[#96c11f] focus:bg-[#96c11f]/5" data-id="element-93" />
      </div>
      <div className="sm:col-span-2 flex justify-end gap-4" data-id="element-94">
        <button type="button" onClick={onComplete} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-[#96c11f] hover:text-white hover:border-[#96c11f]" data-id="element-95">
          Abbrechen
        </button>
        <button type="submit" className="px-4 py-2 bg-[#284755] text-white rounded-md hover:bg-[#96c11f]" data-id="element-96">
          {horse ? 'Aktualisieren' : 'Hinzufügen'}
        </button>
      </div>
    </form>;
};